import { useRouter } from 'next/router'

/**
 * @param id
 * @returns boolean that specifies if a URL has been found in the url path
 * Can be used as a final check for "data ready", example, check if the id from
 * your API response, is found in your current path
 */
const useIsIdFoundInURL = (id) => {
  const router = useRouter()
  const isIdFoundInURL = id && router.asPath.indexOf(id.toString()) > -1 ? true : false

  return isIdFoundInURL
}

export default useIsIdFoundInURL